import script from "./UidName.vue?vue&type=script&setup=true&lang=js"
export * from "./UidName.vue?vue&type=script&setup=true&lang=js"

import "./UidName.vue?vue&type=style&index=0&id=e1216552&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1216552"]])

export default __exports__